import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'engines-old',
});

export const engineDetailsRouteRef = createSubRouteRef({
  id: 'engine_detail',
  parent: rootRouteRef,
  path: '/:engine_udi',
});

export const engineRevisionViewRouteRef = createSubRouteRef({
  id: 'engine_revision_view',
  parent: rootRouteRef,
  path: '/:engine_udi/revision/:revision',
});

export const engineRevisionsRouteRef = createSubRouteRef({
  id: 'engine_revisions',
  parent: rootRouteRef,
  path: '/:engine_udi/revisions',
});

export const engineRevisionCompareRouteRef = createSubRouteRef({
  id: 'engine_revision_compare',
  parent: rootRouteRef,
  path: '/:engine_udi/revisions/:revision1/:revision2',
});

